function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg059SaudiArabia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6DA544"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M159.397,299.472c0,16.006,12.976,28.981,28.981,28.981h86.943   c0,13.338,10.813,24.151,24.151,24.151h28.981c13.339,0,24.151-10.813,24.151-24.151v-28.981H159.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M355.019,159.397v67.623c0,10.654-8.667,19.32-19.32,19.32v28.981   c26.634,0,48.302-21.668,48.302-48.302v-67.623H355.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M147.32,227.019c0,10.654-8.667,19.32-19.32,19.32v28.981c26.634,0,48.302-21.668,48.302-48.302   v-67.623H147.32V227.019z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.552,
    y: 159.399,
    style: {
      fill: "#F0F0F0"
    },
    width: 28.984,
    height: 67.623
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M268.075,198.038c0,2.664-2.167,4.831-4.831,4.831s-4.831-2.167-4.831-4.831v-38.642h-28.981v38.642   c0,2.664-2.167,4.831-4.831,4.831s-4.831-2.167-4.831-4.831v-38.642H190.79v38.642c0,18.643,15.167,33.811,33.811,33.811   c7.18,0,13.84-2.256,19.32-6.088c5.481,3.832,12.141,6.088,19.32,6.088c1.446,0,2.867-0.102,4.266-0.279   c-2.055,8.461-9.673,14.77-18.757,14.77v28.981c26.634,0,48.302-21.668,48.302-48.302v-28.981v-38.642h-28.981v38.642H268.075z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.787,
    y: 246.339,
    style: {
      fill: "#F0F0F0"
    },
    width: 43.475,
    height: 28.984
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg059SaudiArabia);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };